import { Col, Row, Space } from "antd";
import { Form, Formik } from "formik";

import { Button } from "components/elements";
import { Input, Select } from "components/form";
import styles from "../styles/EmployeeFilter.module.css";

import { useTranslation } from "react-i18next";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
const EmployeeFilter = ({
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  shiftDropDown = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
  // const [loading, setLoading] = useState(false);
  // const [imageUrl, setImageUrl] = useState(null);
  // const [optionType, setOptionType] = useState(null);
  const { modifiedStatus = [] } = useStatusFlagOption()
  const statusOption = [
    {
      value: "All",
      name: "All"
    },
    {
      value: "Active",
      name: "Active"
    },
    {
      value: "Inactive",
      name: "Inactive"
    },
    {
      value: "Delete",
      name: "Delete"
    }
  ]

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({
          ...values,
          type: "INCOME"
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (
          <Form>
            <Row gutter={[24, 16]} className={styles.filter} >
              <Col span={12}>
                <Input
                  name="code"
                  label={t("payroll.label.nameorcode")}
                  placeholder={t("payroll.label.nameorcode")}
                  size="large"
                />
              </Col>

              <Col span={12}>
                <Select
                  name="statusFlag"
                  label={t('year_accumulate_list.label.status')}
                  placeholder={t('year_accumulate_list.label.status')}
                  size="large"
                  options={modifiedStatus}
                />
              </Col>

            </Row>
            <Row justify="end">
              <Space size={12} className={styles.filter}>
                <Button type="default" onClick={resetForm}>
                  {t('payroll.reset')}
                </Button>
                <Button type="primary" htmlType="submit">
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default EmployeeFilter;
